import { Box } from '@chakra-ui/react';
import React from 'react';

import { ArrowDir } from '../utils';
import ArrowBody from './ArrowBody';
import Arrowhead from './Arrowhead';
import CurveSection from './CurveSection';
import { ANIM_DURATION, revealFromLeft, revealFromRight } from './constants';

export type StepperItem = {
  key: string;
  dir: ArrowDir;
  bgColor: string;
  tailColor: string;
  isFirst: boolean;
  isLast: boolean;
  isCurrent: boolean;
  ref?: React.RefObject<HTMLDivElement>;
  content: React.ReactNode;
};

type StepperProps = {
  items: StepperItem[];
  animate?: boolean;
};

const Stepper = ({ items, animate = false }: StepperProps) => (
  <Box mb={20}>
    {items.map((item, index) => {
      const animKf = item.dir === 'right' ? revealFromLeft : revealFromRight;

      return (
        <Box
          key={item.key}
          ref={item.ref}
          position="relative"
          zIndex={items.length - index}
          animation={
            animate
              ? `${animKf} ${ANIM_DURATION}s ease-in ${index * ANIM_DURATION}s both`
              : undefined
          }
          sx={animate ? { maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat' } : undefined}
        >
          <CurveSection
            side={item.dir}
            bgColor={item.bgColor}
            display={{ base: 'none', md: item.isFirst ? 'none' : 'block' }}
          />
          <ArrowBody
            side={item.dir}
            bgColor={item.bgColor}
            tailColor={{
              base: item.bgColor,
              md: item.isCurrent ? item.bgColor : item.tailColor,
            }}
            isLast={item.isLast}
            mt={{ base: 2, md: 0 }}
          >
            <Arrowhead
              side={item.dir}
              bgColor={item.bgColor}
              isLast={item.isLast}
              isCurrent={item.isCurrent}
            />
            {item.content}
          </ArrowBody>
        </Box>
      );
    })}
  </Box>
);

export default Stepper;
